<template>
<div>

   <div v-if="templateId === 'generic'" class="annotation__wrapper" :class="classes" ref="textContent" >
      <div class="close" @click="onClose">&#10006;</div>
      <div class="annotation__content" :style="contentStyles">
        <!-- see computed properties in mixins -->
        <span v-if="meta.title" class="annotation__title">{{ title }}</span>
        <span v-if="meta.text" class="annotation__text">{{ text }}</span>
        <span v-if="meta.linkLabel" class="annotation__link" href="#" :style="linkStyles" @click="onClick">{{ linkLabel }}</span>
      </div>
    </div>

  <!--
  <div v-if="templateId === 'generic'" class="generic">
    <h1 v-if="title && title.length > 0" v-text="title"></h1>
    <div data-event="close" class="close">&#10006;</div>
    <p v-if="text" v-text="text"></p>
    <a v-if="linkLabel" :href="URL" target="_blank" tabindex="1" v-text="linkLabel">LINK</a>
  </div>
  -->

  <div v-if="templateId === 'tip'" class="tip">
    <p v-text="title"></p>
    <div data-event="close" class="close">&#10006;</div>
  </div>

  <div v-if="templateId === 'link'" data-event="open" v-bind:data-event-value="URL" data-event-target="_blank" class="link" v-text="linkLabel">
    <div data-event="close" class="close">&#10006;</div>
  </div>

  <div v-if="templateId === 'annotation'" class="annotation">
    <h1 v-text="title"></h1>
    <div data-event="close" class="close">&#10006;</div>
    <p v-text="text"></p>
  </div>

  <div v-if="templateId === 'advanced'" class="advanced"><h1 v-text="title"></h1><div data-event="close" class="close">&#10006;</div>
    <p v-text="text"></p>
    <a :href="URL" target="_blank" tabindex="1">Visit</a>
  </div>

  <div  v-if="templateId === 'includedFrame'" class="embed"><h1 v-text="title"></h1><div data-event="close" class="close">&#10006;</div>
    <p v-text="text"></p>
    <span target="_blank" tabindex="1" data-event="open" data-event-target="iframe" v-bind:data-event-value="URL" v-text="linkLabel">Visit</span>
  </div>

  <div v-if="templateId === 'branchTo'" class="branchTo"><h1 v-text="title"></h1><div data-event="close" class="close">&#10006;</div>
    <p v-text="text"></p>
    <span target="_blank" tabindex="1" data-event="open" data-event-target="_self" v-bind:data-event-value="URL" v-text="linkLabel">Visit</span>
  </div>

</div>
</template>
<script>
import { whiteColor, blackColor } from "./utils";
import { base, titleAndText, linkLabel, URL } from "./mixins/multilang";
import { analytics } from './mixins/analytics/'

const boxSizes = {
  0: "bs-xs",
  1: "bs-s",
  2: "bs-m",
  3: "bs-l",
  4: "bs-xl"
};

export default {
  name: "dynamic2",
  props: ["templateId", "meta", "dimensions", "isLastFrame"],
  mixins: [base, titleAndText, linkLabel, URL, analytics],
  created() {
    console.log("dynamic 2 created", this.meta);
    var cs = this.meta.colorScheme;
    this.colors = cs.colors || {};
    this.onLastFrame = this.meta.onLastFrame
  },
  watch: {
    isLastFrame(isLast) {
      console.log('logicTag isLastFrame %s. current frame %v', isLast, this.frame)
      if (isLast && this.onLastFrame.action !== 'none') {
        this.$emit('action', this.onLastFrame)
      }
    }
  },
  data() {
    return {
      colors: null
    };
  },
  computed: {
    wrapperStyles: function() {
      return {
        color: this.colors[1] || blackColor // set the current color, same as background color, will be inherited from ::before arrow
      };
    },
    contentStyles: function() {
      return {
        color: this.colors[0] || blackColor,
        "background-color": this.colors[1] || whiteColor,
        "border-color": this.colors[2] || whiteColor
      };
    },
    linkStyles: function() {
      return {
        color: this.colors[2] || blackColor
      };
    },
    classes: function() {
      var bs = boxSizes[Math.floor(this.dimensions.w / 320)] || "bs-m";
      var cs = (this.meta.colorScheme || {}).key;
      var align = this.meta.alignement || "h-left";
      var tAlign = this.meta.textAlignement || "t-center";
      console.log("classes", [bs, cs, align, tAlign]);
      return [bs, cs, align, tAlign];
    }
  },
  methods: {
    onClose(ev) {
      this.$emit("action", {
        action: 'close'
      });
      this.$emit("videoaction", {
        action: "play"
      });
    },
    onClick(ev) {
      console.log("onClick", ev);
      ev.preventDefault();
      // suppress mouse out -> play toggle behavoiur
      this.opened = true;
      this.trackTag("Annotation")
      this.$emit("action", this.meta.behaviour);
    }
  }
};
</script>
